import React, { useEffect, useMemo, useState } from "react";
import EnhanceAddToRequisitionList from "./EnhanceAddToRequisitionList";
import Button from "theme/components/atoms/Button";
import Icon from "theme/components/atoms/Icon";
import SelectMenu from "theme/components/molecules/SelectMenu";
import messages from "./AddToRequisitionListMessages";
import { useIntl } from "react-intl";

/** @type {import('./EnhanceAddToRequisitionList').BaseComponent} */
const AddToRequisitionList = ({
  id = "requisition-list",
  areAllOptionsSet,
  requisitionLists,
  size,
  loginModal,
  loadRequisitionLists,
  loadingRequisitionLists,
  loadRequisitionListsError,
  addToRequisitionList,
  addedToRequisitionListId,
  addingToRequisitionList,
  addToRequisitionListError,
  newRequisitionListModal,
  showOptionsModalIfNotFullyConfigured,
  productConfigurationModal,
}) => {
  const intl = useIntl();
  const [isRequisitionListMenuOpen, setIsRequisitionListMenuOpen] =
    useState(false);

  const selectItems = useMemo(() => {
    if (!requisitionLists) {
      return null;
    }
    return [
      {
        value: null,
        text: intl.formatMessage(messages.addToANewREquisitionList),
      },
      ...requisitionLists.map(({ id, name }) => ({
        value: id,
        text: name,
      })),
    ];
  }, [requisitionLists, intl]);

  const onAddToARequisitionList = (requisitionListId) => {
    if (!addingToRequisitionList) {
      addToRequisitionList(requisitionListId);
    }
  };

  useEffect(() => {
    if (addedToRequisitionListId) {
      setIsRequisitionListMenuOpen(false);
    }
  }, [addedToRequisitionListId]);

  const loading = loadingRequisitionLists || addingToRequisitionList;

  const toggleMenu = (e) => {
    if (loading) {
      return;
    }
    setIsRequisitionListMenuOpen(!isRequisitionListMenuOpen);
    if (!requisitionLists) {
      loadRequisitionLists();
    }
    e.stopPropagation();
    e.preventDefault();
  };

  let title;
  if (!areAllOptionsSet && !showOptionsModalIfNotFullyConfigured) {
    title = intl.formatMessage(messages.notAllOptionsSet);
  } else if (loadRequisitionListsError) {
    title = intl.formatMessage(messages.errorLoadingRequisitionLists);
  } else if (addToRequisitionListError) {
    title = addToRequisitionListError;
  } else {
    title = intl.formatMessage(messages.addToARequisitionList);
  }

  let error;
  if (loadRequisitionListsError) {
    error = loadRequisitionListsError;
  } else if (addToRequisitionListError) {
    error = addToRequisitionListError;
  } else if (!areAllOptionsSet && !showOptionsModalIfNotFullyConfigured) {
    error = intl.formatMessage(messages.notAllOptionsSet);
  }

  let icon;
  if (loadRequisitionListsError) {
    icon = "warn";
  } else if (addedToRequisitionListId) {
    icon = "checkmark-circle";
  } else if (addToRequisitionListError) {
    icon = "cross";
  } else {
    icon = "list";
  }

  return (
    <>
      {loginModal}
      {newRequisitionListModal}
      {productConfigurationModal}
      <SelectMenu
        id={`add-to-requisition-list-${id}`}
        message={error}
        items={selectItems}
        isOpen={!loading && isRequisitionListMenuOpen}
        onRequestClose={() => setIsRequisitionListMenuOpen(false)}
        onSelect={onAddToARequisitionList}
      >
        <Button
          state={
            loading
              ? "pending"
              : areAllOptionsSet || showOptionsModalIfNotFullyConfigured
              ? "default"
              : "disabled"
          }
          size={size}
          appearance="icon-block"
          onClick={toggleMenu}
          onDisableClick={() =>
            setIsRequisitionListMenuOpen(!isRequisitionListMenuOpen)
          }
        >
          <Icon title={title} icon={icon} iconSize={size} />
        </Button>
      </SelectMenu>
    </>
  );
};

export default EnhanceAddToRequisitionList()(AddToRequisitionList);
